import dev.shanty.kotwire.stimulus.Controller
import dev.shanty.kotwire.stimulus.StimulusController
import kotlinx.browser.window
import org.w3c.dom.HTMLElement

@JsExport
@StimulusController(targets = ["status"], values = FlightStatusController.Values::class)
class FlightStatusController(context: dynamic) : Controller(context) {

    private val statusEl   by statusTarget<HTMLElement>()
    private val statusUrl  by statusUrlValue()

    object Values { val statusUrl: String = "" }

    override fun connect() {
        if (statusUrl.isNotEmpty()) fetchStatus()
    }

    private fun fetchStatus() {
        val p = window.asDynamic().fetch(statusUrl)
        p.then { r: dynamic -> if (r.ok as Boolean) r.json() else null }
         .then { data: dynamic ->
             if (data != null) renderStatus(data)
             null
         }
         .catch { err: dynamic ->
             console.error("Flight status fetch failed", err)
             null
         }
    }

    private fun formatFlightTime(raw: String, showTimezone: Boolean = true): String {
        val regex = Regex("""(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})([+-]\d{2}:\d{2})""")
        val match = regex.matchEntire(raw.trim()) ?: return raw
        val (year, month, day, hour, minute, offset) = match.destructured
        val formatted = "$day/$month/$year $hour:$minute"
        if (!showTimezone) return formatted
        val sign = offset[0]
        val offsetHours = offset.substring(1, 3).toInt()
        val offsetMinutes = offset.substring(4, 6).toInt()
        val utcLabel = if (offsetMinutes == 0) "UTC$sign$offsetHours"
                       else "UTC$sign$offsetHours:${offsetMinutes.toString().padStart(2, '0')}"
        return "$formatted $utcLabel"
    }

    private fun renderStatus(data: dynamic) {
        val sched  = data.scheduledDeparture as? String
        val est    = data.estimatedDeparture as? String
        val schedArr = data.scheduledArrival as? String
        val estArr   = data.estimatedArrival as? String
        val gate   = data.departureGate as? String
        val term   = data.departureTerminal as? String
        val status = data.status as? String

        val parts = mutableListOf<String>()

        if (sched != null && est != null && est != sched) {
            parts.add("Departure updated: <span class='text-orange-500 font-medium'>${formatFlightTime(est, showTimezone = false)}</span>")
        }

        if (schedArr != null && estArr != null && estArr != schedArr) {
            parts.add("Arrival updated: <span class='text-orange-500 font-medium'>${formatFlightTime(estArr, showTimezone = false)}</span>")
        }

        if (term != null) parts.add("Terminal $term")
        if (gate != null) {
            parts.add("Gate $gate")
        } else if (status != null && status.uppercase() in setOf("BOARDING", "GATE_OPEN", "DEPARTED")) {
            parts.add("<span class='text-gray-400'>Gate TBA</span>")
        }
        if (status != null) parts.add("<span class='text-gray-400'>$status</span>")

        statusEl.innerHTML = parts.joinToString(" · ")
    }
}
